import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    return {
        open: state?.components?.forms?.goPay?.open,
        actionUrl: state?.components?.forms?.goPay?.actionUrl,
    }
}

const hocConnect = (InnerComponent) => connect(mapStateToProps, null)(InnerComponent)

export default hocConnect
